import React, { useState } from 'react';
import { Alert, Box, Stack, TextField, Typography } from '@mui/material';
import { ScribeButton as Button } from '../../components/scribe/ScribeUI';
import { listConsentSourceFiles } from '../../services/clientConsentService';
export default function ConsentDocumentPicker({
  patientId,
  selection,
  onChange,
  disabled
}) {
  const [files, setFiles] = useState(null),
    [loading, setLoading] = useState(false),
    [error, setError] = useState('');
  const load = async () => {
    setLoading(true);
    setError('');
    try {
      setFiles(await listConsentSourceFiles(patientId));
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };
  return <Box sx={{
    mt: 2
  }}>
  <Typography variant="body2" sx={{
      fontWeight: 600,
      mb: 1
    }}>Consent document (optional)</Typography>
  <Typography variant="body2" color="text.secondary" sx={{
      mb: 1
    }}>You may attach a signed consent document if available. PDF, JPG or PNG, up to 10 MB.</Typography>
  <Stack direction="row" gap={1} flexWrap="wrap">
   <Button component="label" variant="outlined" disabled={disabled}>Upload document
    <input aria-label="Consent document" type="file" accept=".pdf,.png,.jpg,.jpeg" hidden disabled={disabled} onChange={e => {
          const file = e.target.files?.[0];
          e.target.value = '';
          if (file) onChange({
            file
          });
        }} />
   </Button>
   <Button variant="outlined" disabled={disabled || loading} onClick={load}>{loading ? 'Loading files…' : 'Select existing file'}</Button>
   {selection && <Button disabled={disabled} onClick={() => onChange(null)}>Remove selection</Button>}
  </Stack>
  {selection && <Typography variant="body2" sx={{
      mt: 1
    }}>{selection.file?.name || selection.existing?.name}</Typography>}
  {error && <Alert severity="error" sx={{
      mt: 1
    }}>{error}</Alert>}
  {files && (!files.length ? <Typography variant="body2" sx={{
      mt: 1
    }}>No eligible files uploaded by you for this client.</Typography> : <TextField select fullWidth size="small" label="Existing client file" SelectProps={{
      native: true
    }} value={selection?.existing?.path || ''} disabled={disabled} sx={{
      mt: 2
    }} onChange={e => {
      const file = files.find(f => f.path === e.target.value);
      onChange(file ? {
        existing: file
      } : null);
    }}>
    <option value="" />{files.map(f => <option key={f.path} value={f.path}>{f.name}</option>)}
   </TextField>)}
 </Box>;
}
